// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"39":"help","231":"vaccination","443":"about","497":"config","842":"map"}[chunkId] + "." + {"39":"649c4746","231":"ff89667d","443":"193f6a5b","497":"4fdfd6a8","842":"471be6cf"}[chunkId] + ".css";
};